import React, { useState, useEffect } from 'react'
import { Col, Container, Row, Button } from "react-bootstrap"
import { FaHistory, FaPlus } from 'react-icons/fa'
import $ from 'jquery';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import RoleConfiguration from './RoleConfiguration'
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import N from '../lib/Network';
import S from '../lib/Security';
var CryptoJS = require("crypto-js");
const ManageRoleConfiguration = () => {
    const [showUserPopup, setShowUserPopup] = useState(false);
    const [showUserPopupEdit, setShowUserPopupEdit] = useState(false);
    const [data, setData] = useState([]);
    const [oldRecord,setOldRecord] = useState([]);
    useEffect(() => {
        getKeys();
       fetchdatatableData();
        //initialize datatable viewUser
        setTimeout(function () {
            $('#viewRole').DataTable({
                pagingType: 'full_numbers',
                pageLength: 10,
                dom: 'Bfrtip',
                "order": [[ 1, "aesc" ]],
                "columns":[  
                    { 'searchable': true },  
                    { 'searchable': false },  
                    { 'searchable': false },  
                    { 'searchable': false }, 
                    {},
                ],
                language: { search: "", searchPlaceholder: "Search By User Name"},
                buttons: [
                    {
                        text: '<i class="fa fa-print" />',
                        className: 'custom-btn',
                        extend: 'print'
                    },
                    {
                        text: '<i class="fa fa-file-excel-o" />',
                        className: 'custom-btn',
                        extend: 'csv'
                    }
                ],
                bDestroy: true,
            });
        }, 1400 );
    }, []);
    const fetchdatatableData = () => {
        N.getApi('getUserList')
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setData(JSON.parse(response.responseJson))
        })
    }
    function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
          N.getRSAApi('/getRsaKeys')
          .then(res => {
              let resObj = JSON.parse(res.data);
              let resJson = JSON.parse(resObj.responseJson);
              if(resJson.privateKey && resJson.publicKey){
                  let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                  // Decrypt
                  var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
      
                  var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
              }
          })
          .catch(err => {
              console.log("Error : "+err);
          });
        }
      }
    const openPreviewModalHandler = () => { setShowUserPopup(true)  }
    const closePopup = () => { setShowUserPopup(false) }
    const closeEditPopup = () => { setShowUserPopupEdit(false) }
    const handleEdit =(oldData)=>{setOldRecord({oldData});setShowUserPopupEdit(true); }
    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="wrapper">
                {<Sidebar />}
                {<Topbar />}
                {/* <!-- End of Topbar --> */}
                {/* <!-- Main Content --> */}
                <div id="content">
                    {/* <!-- Begin Page Content --> */}
                    <Container fluid>
                        <Row>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 mb-2 mt-2">
                                <div className="card dash-data-card">
                                    <div className="card-header pl-4 pr-4">
                                        <h5 className="headerTitle float-left">Role Configuration</h5>
                                        <Button type="button" className="btn btn-sm btn-primary shadow-sm float-right ml-2" title="Audit Log">
                                            <FaHistory className="fas fa-plus" /><b style={{verticalAlign: 'middle'}}>Audit Log</b>
                                        </Button>
                                        <Button type="button" className="btn btn-sm btn-primary shadow-sm float-right" onClick={openPreviewModalHandler}>
                                            <FaPlus className="fas fa-plus pr-1" /><b style={{verticalAlign: 'middle'}}>Create Role</b>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row className="mb-3">
                            <Col lg='12'>
                                <div className="card dash-data-card">
                                    <div className="card-body pl-4 pr-4">
                                        <table id="viewRole" className="display">
                                            <thead>
                                                <tr>
                                                    <th>User Name</th>
                                                    <th>User Code</th>
                                                    <th>User FullName</th>
                                                    <th>User Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <RoleConfiguration showUserPopup={showUserPopup} closeModal={closePopup}/>
                    {/* {showUserPopupEdit ? <>
                    <EditUser oldRecord={oldRecord} showUserPopupEdit={showUserPopupEdit} closeEditModal={closeEditPopup}/>
                    </>:null
                    } */}
                    {/* <!-- /.container-fluid --> */}
                </div>
                
                {/* <!-- End of Main Content --> */}
            </div>
            {/* <!-- End of Content Wrapper --> */}
        </div>
    )
} 
export default ManageRoleConfiguration;